import { IndexModel } from "../Support/IndexModel";
export class AccountProductIndex extends IndexModel {
    slug;
    endpoint = 'product';
    constructor(params) {
        super();
        this.filters = {
            account: this.slug = params.slug
        };
    }
    getData() {
        return super.getData();
    }
}
